"use strict";

var _defineProperty = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
}); // accessor class for the on-chain version registry

var ethereumjs_util_1 = require("ethereumjs-util");

function string32(s) {
  return ethereumjs_util_1.bufferToHex(Buffer.from(s)).padEnd(66, '0');
}

exports.string32 = string32; // convert a bytes32 into a string, removing any trailing zeros

function bytes32toString(s) {
  return Buffer.from(s.replace(/^(?:0x)?(.*?)(00)*$/, '$1'), 'hex').toString();
}

exports.bytes32toString = bytes32toString;

var VersionRegistry = /*#__PURE__*/function () {
  function VersionRegistry(fromBlock, contractInteractor) {
    _classCallCheck(this, VersionRegistry);

    this.fromBlock = fromBlock;
    this.contractInteractor = contractInteractor;
  }

  _createClass(VersionRegistry, [{
    key: "isValid",
    value: function () {
      var _isValid = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var versionRegistryAddress;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // validate the contract exists, and has the registry API
                versionRegistryAddress = this.contractInteractor.getDeployment().versionRegistryAddress;

                if (!(versionRegistryAddress == null)) {
                  _context.next = 3;
                  break;
                }

                throw new Error('Version Registry address is not provided.');

              case 3:
                _context.next = 5;
                return this.contractInteractor.getCode(versionRegistryAddress);

              case 5:
                _context.t0 = _context.sent;

                if (!(_context.t0 === '0x')) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", false);

              case 8:
                return _context.abrupt("return", true);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function isValid() {
        return _isValid.apply(this, arguments);
      }

      return isValid;
    }()
    /**
     * return the latest "mature" version from the registry
     *
     * @dev: current time is last block's timestamp. This resolves any client time-zone discrepancies,
     *  but on local ganache, note that the time doesn't advance unless you mine transactions.
     *
     * @param id object id to return a version for
     * @param delayPeriod - don't return entries younger than that (in seconds)
     * @param optInVersion - if set, return this version even if it is young
     * @return version info that include actual version used, its timestamp and value.
     */

  }, {
    key: "getVersion",
    value: function () {
      var _getVersion = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id, delayPeriod) {
        var optInVersion,
            _yield$Promise$all,
            _yield$Promise$all2,
            versions,
            now,
            ver,
            _args2 = arguments;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                optInVersion = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : '';
                _context2.next = 3;
                return Promise.all([this.getAllVersions(id), this.contractInteractor.getBlock('latest').then(function (b) {
                  return b.timestamp;
                })]);

              case 3:
                _yield$Promise$all = _context2.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                versions = _yield$Promise$all2[0];
                now = _yield$Promise$all2[1];
                ver = versions.find(function (v) {
                  return !v.canceled && (v.time + delayPeriod <= now || v.version === optInVersion);
                });

                if (!(ver == null)) {
                  _context2.next = 10;
                  break;
                }

                throw new Error("getVersion(".concat(id, ") - no version found"));

              case 10:
                return _context2.abrupt("return", ver);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getVersion(_x, _x2) {
        return _getVersion.apply(this, arguments);
      }

      return getVersion;
    }()
    /**
     * return all version history of the given id
     * @param id object id to return version history for
     */

  }, {
    key: "getAllVersions",
    value: function () {
      var _getAllVersions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(id) {
        var events, cancelReasons, found;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.contractInteractor.getPastEventsForVersionRegistry(['VersionAdded', 'VersionCanceled'], [string32(id)], {
                  fromBlock: this.fromBlock
                });

              case 2:
                events = _context3.sent;
                // map of ver=>reason, for every canceled version
                cancelReasons = events.filter(function (e) {
                  return e.event === 'VersionCanceled';
                }).reduce(function (set, e) {
                  return Object.assign(Object.assign({}, set), _defineProperty({}, e.returnValues.version, e.returnValues.reason));
                }, {});
                found = new Set();
                return _context3.abrupt("return", events.filter(function (e) {
                  return e.event === 'VersionAdded';
                }).map(function (e) {
                  return {
                    version: bytes32toString(e.returnValues.version),
                    canceled: cancelReasons[e.returnValues.version] != null,
                    cancelReason: cancelReasons[e.returnValues.version],
                    value: e.returnValues.value,
                    time: parseInt(e.returnValues.time)
                  };
                }).filter(function (e) {
                  // use only the first occurrence of each version
                  if (found.has(e.version)) {
                    return false;
                  } else {
                    found.add(e.version);
                    return true;
                  }
                }).reverse());

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getAllVersions(_x3) {
        return _getAllVersions.apply(this, arguments);
      }

      return getAllVersions;
    }() // return all IDs registered

  }, {
    key: "listIds",
    value: function () {
      var _listIds = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var events, ids;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.contractInteractor.getPastEventsForVersionRegistry(['VersionAdded'], [], {
                  fromBlock: this.fromBlock
                });

              case 2:
                events = _context4.sent;
                ids = new Set(events.map(function (e) {
                  return bytes32toString(e.returnValues.id);
                }));
                return _context4.abrupt("return", Array.from(ids));

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function listIds() {
        return _listIds.apply(this, arguments);
      }

      return listIds;
    }()
  }, {
    key: "addVersion",
    value: function () {
      var _addVersion = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(id, version, value, transactionDetails) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.checkVersion(id, version, false);

              case 2:
                _context5.next = 4;
                return this.contractInteractor.addVersionInVersionRegistry(string32(id), string32(version), value, transactionDetails);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function addVersion(_x4, _x5, _x6, _x7) {
        return _addVersion.apply(this, arguments);
      }

      return addVersion;
    }()
  }, {
    key: "cancelVersion",
    value: function () {
      var _cancelVersion = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(id, version, cancelReason, transactionDetails) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.checkVersion(id, version, true);

              case 2:
                _context6.next = 4;
                return this.contractInteractor.cancelVersionInVersionRegistry(string32(id), string32(version), cancelReason, transactionDetails);

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function cancelVersion(_x8, _x9, _x10, _x11) {
        return _cancelVersion.apply(this, arguments);
      }

      return cancelVersion;
    }()
  }, {
    key: "checkVersion",
    value: function () {
      var _checkVersion = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(id, version, validateExists) {
        var versions;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.getAllVersions(id).catch(function () {
                  return [];
                });

              case 2:
                versions = _context7.sent;

                if (!(versions.find(function (v) {
                  return v.version === version;
                }) != null !== validateExists)) {
                  _context7.next = 5;
                  break;
                }

                throw new Error("version ".concat(validateExists ? 'does not exist' : 'already exists', ": ").concat(id, " @ ").concat(version));

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function checkVersion(_x12, _x13, _x14) {
        return _checkVersion.apply(this, arguments);
      }

      return checkVersion;
    }()
  }]);

  return VersionRegistry;
}();

exports.VersionRegistry = VersionRegistry;